::ng-deep mat-radio-group mat-radio-button .mat-radio-label{align-items:start}::ng-deep mat-radio-group mat-radio-button .mat-radio-label .mat-radio-label-content .hint{color:#777;font-size:.75rem;padding-top:5px}
/*# sourceMappingURL=reference-notification-settings.component-532LGGSU.css.map */
